<template>
  <div class="h-troop-list flex">
    <div v-click-sound-button
         v-for="(item, index) in troopCreatures"
         class="troop-item h-outer-border around-4 bz1 bw2"
         :class="{empty: !item.name, active: index === selectedRecruitedCreatureIndex}"
         @click="selectRecruitedCreature(index)">
      <img v-if="item.name" :src="`${$rHost}/img/creature/avatar/${item.name}.jpg`" alt="">
      <div v-if="item.name" class="amount">{{ item.amount }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      troopCreatures: new Array(7).fill({}),
      selectedRecruitedCreatureIndex: null
    }
  },

  props: {
    troopData: {
      type: Array,
      default () {
        return []
      }
    },

    allowMerge: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    troopData: {
      handler (val) {
        if (val) {
          const data = []
          val.forEach((item) => {
            const name = Object.keys(item)[0]
            const amount = item[name]
            data.push({
              name: name,
              amount: amount
            })
          })
          this.selectedRecruitedCreatureIndex = null
          this.troopCreatures = data
        }
      },
      immediate: true
    }
  },

  methods: {
    selectRecruitedCreature (index) {
      if (this.selectedRecruitedCreatureIndex === null) {
        if (this.troopCreatures[index].name) {
          this.selectedRecruitedCreatureIndex = index
        }
      } else if (index === this.selectedRecruitedCreatureIndex) {
        this.selectedRecruitedCreatureIndex = null
      } else if (index !== this.selectedRecruitedCreatureIndex) {
        const data = JSON.parse(JSON.stringify(this.troopCreatures))
        // 合并
        if (this.allowMerge && data[this.selectedRecruitedCreatureIndex].name === data[index].name) {
          data[index].amount += data[this.selectedRecruitedCreatureIndex].amount
          data[this.selectedRecruitedCreatureIndex] = {}
          this.troopCreatures = data
          this.selectedRecruitedCreatureIndex = null
        } else {
          // 交换位置
          let temp = data[this.selectedRecruitedCreatureIndex]
          data[this.selectedRecruitedCreatureIndex] = data[index]
          data[index] = temp
          this.troopCreatures = data
          this.selectedRecruitedCreatureIndex = null
        }
      }
    },

    getTroop () {
      let troop = []
      this.troopCreatures.forEach((d) => {
        troop.push({ [d.name]: d.amount })
      })
      return troop
    }
  }
}
</script>

<style lang="stylus" scoped>
  .h-troop-list
    user-select none
    display flex
    justify-content space-evenly
    .troop-item
      overflow hidden
      position relative
      display flex
      justify-content center
      align-items center
      width 84px
      height 93px
      padding 4px
      > img
        border 2px solid #000
        width 100%
      .amount
        z-index 1
        position absolute
        bottom 4px
        right 5px
        font-size 14px
        whiteText1()
      &.active > img
        border 2px solid $colorGold
      &:not(:last-child)
        margin-right 1px
</style>
